//import { debounce } from 'lodash-es';
import Pusher, { Channel } from 'pusher-js/with-encryption';

Pusher.logToConsole = PUBLIC_MODE === 'development';

class EventManager {
  private pusher = new Pusher(PUBLIC_PUSHER_APP_KEY, {
    cluster: 'eu',
  });

  private channel: Channel | undefined;

  init(userId: number) {
    this.channel = this.pusher.subscribe(`users.${userId}`);
  }

  listenOffersExpiryEvent({ action }: { action: () => void }) {
    if (this.channel) {
      this.channel.bind(`offer.expired`, action);
    }
  }

  listenOffersUpdateEvent({ action }: { action: (data: any) => void }) {
    if (this.channel) {
      this.channel.bind(`offer.updated`, action);
    }
  }
  listenPointUpdateEvent({ action }: { action: (data: any) => void }) {
    if (this.channel) {
      this.channel.bind(`point.updated`, action);
    }
  }
}

export const GLOBAL_EVENT_MANAGER = new EventManager();
